<template>
  <div class="blacklist-main-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><svg-icon icon-class="blacklist" /> Main Blacklist</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="createMainBlacklist"
          ><i class="el-icon-plus"></i> Add Blacklist</el-button
        >
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            label="Name"
            prop="name"
            min-width="200"
          >

          </el-table-column>
          <el-table-column
            label="Exactly Match"
            prop="exactlyMatch"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="`${!scope.row.exactlyMatch ? 'info' : ''}`">
                {{ scope.row.exactlyMatch ? "Yes" : "No" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="Action" prop="uid" width="180" align="center">
            
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="editBlacklist(scope.row.uid)"
              >
                Edit
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteBlacklist(scope.row.uid, scope.row.name)"
              >
                Del
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="formDataRules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="Name" prop="name">
          <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Exactly Match">
          <el-select v-model="formData.exactlyMatch">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitBlacklist" :loading="submitting"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMainBlacklist,
  getMainBlacklistByUID,
  createMainBlacklist,
  putMainBlacklist,
  deleteMainBlacklist,
} from "@/api/firewall-blacklist";
export default {
  data() {
    return {
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      actionDialog: "add",
      editUID: "",
      titleDialog: "Create Main Blacklist",
      tableData: [],
      formData: {
        name: "",
        exactlyMatch: false,
      },
      formDataRules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getMainBlacklist() {
      this.loading = true;
      getMainBlacklist().then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.tableData = data;
        }
      });
    },
    createMainBlacklist(){
      this.dialogFormVisible = true; 
      this.actionDialog='add'
      this.titleDialog = "Create Main Blacklist"
    },
    submitBlacklist() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if(this.actionDialog === 'add'){
            createMainBlacklist(this.formData).then(({ result, message }) => {
              this.submitting = false;
              if (result) {
                this.dialogFormVisible = false;
                this.getMainBlacklist();
                this.resetForm();
              }else{
                this.$message.error(message);
              }
            });
          }else{
            putMainBlacklist(this.editUID, this.formData).then(({result, message})=>{
              this.submitting = false;
              if(result){
                this.dialogFormVisible = false;
                this.editUID = ""
                this.getMainBlacklist();
                this.resetForm();
              }else{
                this.$message.error(message);
              }
            })
          }

        }
      });
    },
    editBlacklist(uid) {
      this.loading = true;
      this.editUID = uid;
      this.titleDialog = "Edit Main Blacklist";
      getMainBlacklistByUID(uid).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.formData.name = data.name;
          this.formData.exactlyMatch = data.exactlyMatch ? true : false;
          this.actionDialog = "edit";
          this.dialogFormVisible = true;
        }
      });
      
    },
    deleteBlacklist(uid, name) {
      this.$confirm(
        `This will delete ${name} . Continue?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          deleteMainBlacklist( uid ).then(({ result, message }) => {
            this.loading = false;
            if (result) {
              this.getMainBlacklist();
            } else {
              this.$message.error(message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    resetForm(){
      this.formData.name = ""
      this.formData.exactlyMatch = false
    }
  },
  mounted() {
    this.getMainBlacklist();
  },
};
</script>

<style lang="scss">
.blacklist-main-content {
  padding: 20px;
}
</style>